import { render, staticRenderFns } from "./ExhibitorCard.vue?vue&type=template&id=183f307e&scoped=true&"
import script from "./ExhibitorCard.vue?vue&type=script&lang=js&"
export * from "./ExhibitorCard.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitorCard.vue?vue&type=style&index=0&id=183f307e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183f307e",
  null
  
)

export default component.exports